(() => {
  const fmtGBP = (n) =>
    new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);

  function tierPrice(qty, breaks, fallback) {
    let p = fallback;
    for (const b of breaks) if (qty >= b.min) p = b.price;
    return p;
  }

  function parseBreaks(jsonEl) {
    if (!jsonEl) return null;
    try {
      const raw = JSON.parse(jsonEl.textContent.trim());
      if (!Array.isArray(raw) || !raw.length) return null;

      return raw
        .map((b) => ({ min: Number(b.min), price: Number(b.price) }))
        .filter((b) => Number.isFinite(b.min) && Number.isFinite(b.price))
        .sort((a, b) => a.min - b.min);
    } catch (e) {
      console.warn("TTC volume pricing JSON parse failed:", e);
      return null;
    }
  }

  function getFallbackPrice(priceWrap) {
    // Grab first visible price item
    const first = priceWrap.querySelector(".price .price-item");
    if (!first) return 0;

    if (!first.dataset.ttcOriginal) first.dataset.ttcOriginal = first.textContent.trim();
    const txt = first.dataset.ttcOriginal || "";
    const n = Number(txt.replace(/[^0-9.]/g, ""));
    return Number.isFinite(n) ? n : 0;
  }

  function updateWithinProductInfo(productInfo) {
    const jsonEl = productInfo.querySelector('script[id^="TTC-VolumeBreaks-"]');
    const breaks = parseBreaks(jsonEl);
    if (!breaks) return;

    const qtyEl = productInfo.querySelector('input[id^="Quantity-"].quantity__input');
    const priceWrap = productInfo.querySelector('[id^="price-"]');
    if (!qtyEl || !priceWrap) return;

    const priceItems = priceWrap.querySelectorAll(".price .price-item");
    if (!priceItems.length) return;

    // store originals once
    priceItems.forEach((el) => {
      if (!el.dataset.ttcOriginal) el.dataset.ttcOriginal = el.textContent.trim();
    });

    const fallback = getFallbackPrice(priceWrap);

    const qty = Math.max(1, parseInt(qtyEl.value || "1", 10));
    const p = tierPrice(qty, breaks, fallback);
    const formatted = fmtGBP(p);

    // Update all numeric price parts in main block
    priceItems.forEach((el) => (el.textContent = formatted));

    // OPTIONAL: if you have a visible "£X each" text outside .price-item, update it too:
    // Add class="ttc-each-price" to that element in Liquid and it will update.
    productInfo.querySelectorAll(".ttc-each-price").forEach((el) => (el.textContent = `${formatted} each`));
  }

  function getProductInfoFromTarget(target) {
    return target.closest("product-info");
  }

  // Listen globally so it survives Shopify section swaps
  document.addEventListener("input", (e) => {
    if (!e.target.matches('input[id^="Quantity-"].quantity__input')) return;
    const productInfo = getProductInfoFromTarget(e.target);
    if (productInfo) updateWithinProductInfo(productInfo);
  });

  document.addEventListener("change", (e) => {
    if (!e.target.matches('input[id^="Quantity-"].quantity__input')) return;
    const productInfo = getProductInfoFromTarget(e.target);
    if (productInfo) updateWithinProductInfo(productInfo);
  });

  // Handle +/- buttons (they change the input value via stepUp/stepDown)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".quantity__button");
    if (!btn) return;
    const productInfo = getProductInfoFromTarget(btn);
    if (!productInfo) return;

    // wait a tick for the input value to update
    setTimeout(() => updateWithinProductInfo(productInfo), 0);
  });

  // Initial run
  function initAll() {
    document.querySelectorAll("product-info").forEach(updateWithinProductInfo);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();